import { render, staticRenderFns } from "./CityInfo.vue?vue&type=template&id=64e2a7c5"
import script from "./CityInfo.vue?vue&type=script&lang=js"
export * from "./CityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports